<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="name" class="mb10" style="width: 240px" placeholder="请输入原材料名称" clearable />
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="handleAddPageClass('add')">+添加原材料</el-button>
            <el-button class="ml10 mb10" type="primary" @click="importClass()"
              v-if="checkPermission(['importClass'])">导入</el-button>

          </div>
        </el-col>
      </el-row>
      <!--        <el-button class="ma" type="primary" @click="handleAddCustomer('add')">+添加客户</el-button>-->
    </div>

    <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border lazy :load="load"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="name" align="center" label="名称" />
      <el-table-column prop="specName" align="center" label="规格">
        <template slot-scope="scope">
          {{ scope.row.specName || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="modelNo" align="center" label="型号">
        <template slot-scope="scope">
          {{ scope.row.modelNo || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="inventCode" align="center" label="库存编码">
        <template slot-scope="scope">
          {{ scope.row.inventCode || '--' }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="sectionalArea" align="center" label="截面积">
        <template slot-scope="scope">
          {{ scope.row.sectionalArea || '--' }}
        </template>
      </el-table-column> -->
      <el-table-column prop="width" align="center" label="宽度">
        <template slot-scope="scope">
          {{ scope.row.width || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="thickness" align="center" label="厚度">
        <template slot-scope="scope">
          {{ scope.row.thickness || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="density" align="center" label="密度">
        <template slot-scope="scope">
          {{ scope.row.density || '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="length" align="center" label="长度">
        <template slot-scope="scope">
          {{ scope.row.length || '--' }}
        </template>
      </el-table-column>
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editCustomer(scope.row)" v-if="!userInfo.branchId">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" @confirm="delPageClass(scope.row)"
            icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text"
              v-if="!userInfo.branchId">删除</el-button>
          </el-popconfirm>
          <el-button slot="reference" class="ml10" @click="printClass(scope.row,2)" type="text"
            v-if="scope.row.hasChildren">打印子级</el-button>
          <el-button slot="reference" class="ml10" @click="printClass(scope.row,1)" type="text">打印</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" class=""
        :total="total" :pager-count="5" />
    </div>



    <!-- <commonTable
      :tableData="tableData"
      :total="total"

      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:table>
        <el-table-column
          prop="name"
          align="center"
          label="名称"
        />
        <el-table-column
            prop="sort"
            align="center"
            label="排序"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="创建时间"
        />
        <el-table-column align="center" width="200" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editCustomer(scope.row)">编辑</el-button>
            <customPopconfirm confirm-button-text="确定" k cancel-button-text="取消"
                              @confirm="delPageClass(scope.row)" icon="el-icon-info" icon-color="red" title="确定要删除吗？">
              <el-button slot="reference" class="ml10" style="color: #fd634e" type="text" >删除</el-button>
            </customPopconfirm>
          </template>
        </el-table-column>
      </template>
    </commonTable> -->

    <AddPageClassDialog ref="addPageClassDialog" @getList="getList"></AddPageClassDialog>
    <ImportClassDialog ref="importClassDialog" @getList="getList"></ImportClassDialog>

    <class-print ref="classPrint"></class-print>
  </div>
</template>

<script>
  import AddPageClassDialog from './component/AddPageClassDialog'
  import ClassPrint from "../storePageClass/component/classPrint.vue";
  // import commonTable from "@/components/common/commonTable";
  // import customPopconfirm from "@/components/common/customPopconfirm";
  import { deleteCustomPageClass, pageClassList, noPage } from '@/api/customPageClass.js'
  import { checkPermission } from "@/directives/permission";
  import ImportClassDialog from "@/components/ImportClassDialog.vue";
  export default {
    components: {
      ClassPrint,
      // commonTable,
      AddPageClassDialog,
      ImportClassDialog
      // customPopconfirm
    },
    props: {
      classType: {
        default: 1
      }
    },
    data() {
      return {
        name: null,
        tableData: [],
        pageSize: 10,
        pageNum: 1,
        total: 0,
        currentPage: 1,
        userInfo: ''
      };
    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      this.getList()
    },
    methods: {
      checkPermission,
      load(tree, treeNode, resolve) {
        setTimeout(() => {
          let params = {
            noPage: true,
            name: this.name,
            classType: 1,
            status: this.storeStatus,
            parentId: tree.id
          }
          pageClassList(params).then(res => {
            resolve(res.data.list)
          })
        }, 1000)
      },
      importClass() {
        //导入产品类别
        this.$refs.importClassDialog.openDialog(this.classType)
      },
      getCustomer() {
        this.getList()
      },
      printClass(row, type) {
        if (1 == type) {
          //单个
          this.$refs.classPrint.init([row])
        } else if (2 == type) {
          //打印子级
          if (!row.hasChildren) {
            this.$message.error('该类别下没有子级')
            return;
          } else {
            if (!row.children || row.children.length <= 0) {
              let params = {
                noPage: true,
                classType: 1,
                parentId: row.id
              }
              pageClassList(params).then(res => {
                if (res.data.list) {
                  this.$refs.classPrint.init(res.data.list)
                }
              })
            }
          }
        }
      },
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.getList();
      },
      handleCurrentChange(num) {
        this.pageNum = num;
        this.getList();
      },
      handleAddPageClass(type, id) {
        this.$refs.addPageClassDialog.openDialog(type, id, this.classType)
      },
      getList() {
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          type: 0,
          name: this.name,
          classType: this.classType
        }
        pageClassList(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.total
        })
      },
      editCustomer(data) {
        this.$refs.addPageClassDialog.openDialog('edit', data, this.classType)
      },
      delPageClass(data) {
        deleteCustomPageClass(data.id).then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.getList()
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
      },
      lookImg(row) {
        this.$router.push({
          path: '/classImgList', query: {
            id: row.id,
            name: row.name,
          },
        })
      }
    },

  }
</script>

<style lang="scss" scoped>
  .ml10 {
    margin-left: 10px;
  }

  .pageBox {
    display: flex;
    justify-content: flex-end;
  }
</style>